import { theme } from "../theme";
export const createResponsiveStyles = ({ base, ...breakpointStyles }) => {
    return {
        ...base,
        ...Object.entries(breakpointStyles).reduce((final, [screen, styles]) => {
            if (styles) {
                final[`@media (min-width: ${theme.screens[screen]}px)`] = {
                    ...styles,
                };
            }
            return final;
        }, {}),
    };
};
//# sourceMappingURL=createResponsiveStyles.js.map